























































import Vue from 'vue';
import moment from 'moment';
import { errorToMessage } from '@/core/utils/errors';
import { mapGetters } from 'vuex';
import { ValidationObserver } from 'vee-validate';

interface LocalState {
  expirationDate: Date | null;
  addingRedemption: boolean;
}
export default Vue.extend({
  name: 'AddRedemptionModal',
  components: { ValidationObserver },
  props: {
    productId: {
      type: Number || null,
    },
  },
  computed: {
    ...mapGetters({
      allActiveTeacherProducts: 'product/allActiveTeacherProducts',
      teacherProducts: 'product/teacherProducts',
    }),
    minDate() {
      return moment().add(1, 'day').toDate();
    },
    eventClassCardProducts() {
      if (!this.allActiveTeacherProducts) return [];
      return this.allActiveTeacherProducts.filter(
        product => ['punch_card'].indexOf(product.product_type) !== -1
      );
    },
  },
  data(): LocalState {
    return {
      expirationDate: moment().startOf('day').add(30, 'days').toDate(),
      addingRedemption: false,
      classcard: this.productId,
      numberOfRedemptions: 1,
    };
  },
  methods: {
    classCardSelected(productId) {
      if (!productId) return;
      const classCard = this.eventClassCardProducts.filter(
        p => p.id == productId
      )[0];
      // assign defaults from the ClassCard
      if (classCard.punchcard_expiration_days) {
        this.expirationDate = moment()
          .startOf('day')
          .add(classCard.punchcard_expiration_days, 'days')
          .toDate();
      } else {
        this.expirationDate = null;
      }
      this.numberOfRedemptions = classCard.number_of_punches;
    },
    async onConfirm(): Promise<void> {
      this.addingRedemption = true;
      try {
        let expirationDays = null;
        if (this.expirationDate) {
          expirationDays = moment(this.expirationDate)
            .startOf('day')
            .diff(moment().startOf('day'), 'days');
        }
        const payload = {
          expirationDays: expirationDays,
          notificationDays: 7,
          numberOfRedemptions: this.numberOfRedemptions,
          productId: this.classcard,
        };
        await this.$store.dispatch('sale/addCustomerPunch', payload);
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t('CUSTOMERS.NOTIFICATIONS.REDEMPTION_ADD_SUCCESS'),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to add redemption',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      } finally {
        this.addingRedemption = false;
      }
      this.$emit('close');
    },
  },
  mounted() {
    if (!this.teacherProducts) {
      this.$store.dispatch('product/getTeacherProducts');
    }
  },
});
